import React, { Component } from "react";
import ErrorModal from "../../components/Modal/ErrorModal";
import gql from "graphql-tag";
import banner_default from "../../assets/img/portoEduc_Bn_Biblioteca_Home.jpg";
import Config from "../../config/config";
import HttpLinkServices from "../../services/HttpLinkServices";
import Button from "../../components/CustomButton/CustomButton.jsx";
import { Grid, Row, Col } from "react-bootstrap";
import { NavItem, Nav, NavDropdown } from "react-bootstrap";
import { Query } from "react-apollo";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { addToDataLayerGTM } from "../../utils/addToDataLayerGTM";
import Paginator from "../../components/Paginator";
import { formattedCurrentDate } from "../../utils/dateFormat";
import SearchNotFound from "../../components/SearchNotFound";

const dam_client = new ApolloClient({
  link: HttpLinkServices.dam,
  cache: new InMemoryCache()
});

const GET_DAM = gql`
  query getDam(
    $module_name: String!
    $category_id: Int!
    $limit: Int!
    $page: Int!
  ) {
    assets_collections(
      limit: $limit
      order: "Desc"
      module_name: $module_name
      category_id: $category_id
      page: $page
    ) {
      assets {
        id
        title
        asset
        thumbnail
        is_viewed
      }
    }
  }
`;

const QUERY_QUANTIDADE_MEDIAS = gql`
  query media_count($category_id: Int!) {
    assets_collections_count(module_name: "Media", category_id: $category_id) {
      count
    }
  }
`;

const GET_CATEGORIES = gql`
  {
    category_collections(parent: null, type_content: "assets") {
      categories {
        id
        title
      }
    }
  }
`;

const GET_SUBCATEGORIES = gql`
  query getCagegories($parent_id: Int!) {
    category_collections(parent: $parent_id, type_content: "assets") {
      categories {
        id
        title
      }
    }
  }
`;

const GET_CATEGORY = gql`
  query getCategory($category_id: Int!) {
    category(id: $category_id) {
      banner
    }
  }
`;

class MediaCenter extends Component {
  constructor() {
    super();
    this.category_id = 0;
    this.state = {
      page: 1,
      limit: 6,
      totalMedia: 0
    };
  }

  quantidadeMedias() {
    dam_client
      .query({
        query: QUERY_QUANTIDADE_MEDIAS,
        variables: { category_id: this.category_id }
      })
      .then(result =>
        this.setState({
          totalMedia: result.data.assets_collections_count.count
        })
      );
  }

  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json["names"].length; i++) {
      var type = "fa fa-circle text-" + json["types"][i];
      legend.push(<i className={type} key={i} />);
      legend.push(" ");
      legend.push(json["names"][i]);
    }
    return legend;
  }

  componentDidMount() {
    this.quantidadeMedias();
    if (this.props.match.path === "/conteudos-digitais") {
      // Google Tag Manager
      const dataLayer = {
        event: "step_change",
        etapa: "/conteudos-digitais/biblioteca/"
      };
      addToDataLayerGTM(dataLayer);
    }
  }

  handleDownloadGTM(item) {
    const successOrError = item.id && item.asset && Config.baseUrl;
    //Google Tag Manager
    const dataLayer = {
      event: "solicitacao_servico",
      nome_servico: "download_biblioteca",
      nome_curso: item.title,
      data_servico: formattedCurrentDate(),
      produto: item.title,
      brand: "porto seguro",
      retorno: successOrError ? "sucesso" : "erro",
      descricao: successOrError
        ? "download realizado com sucesso"
        : "erro ao realizar download"
    };
    addToDataLayerGTM(dataLayer);
  }

  handleClickSubCategoriesGTM(category, subCategory) {
    // Google Tag Manager
    const dataLayer = {
      event: "step_change",
      etapa: `/conteudos-digitais/biblioteca/${category}/${subCategory}`
    };
    addToDataLayerGTM(dataLayer);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.match.params.category_id !== this.props.match.params.category_id
    ) {
      this.quantidadeMedias(this.props.match.params.category_id);
      this.setState({ page: 1 });
    }
  }

  render() {
    this.category_id = this.props.match.params.category_id
      ? this.props.match.params.category_id
      : 0;

    return (
      <div className="">
        <Query
          client={dam_client}
          query={GET_CATEGORY}
          variables={{ category_id: this.category_id }}
        >
          {({ loading, error, data }) => {
            if (loading) return <div>Carregando...</div>;
            if (error) {
              // Google Tag Manager
              addToDataLayerGTM({
                event: "erro",
                etapa: "erro ao buscar categoria"
              });
              return <ErrorModal />;
            }

            return (
              <img
                className="banner_content"
                src={
                  data.category && data.category.banner
                    ? Config.baseUrl + "/dam/assets/" + data.category.banner
                    : banner_default
                }
              />
            );
          }}
        </Query>
        <div className="container">
          <Grid fluid>
            <Row>
              <div className="contentMenu">
                <Nav>
                  <NavItem
                    data-gtm-type="click"
                    data-gtm-clicktype="submenu"
                    data-gtm-name="Todos"
                    href={"/#/conteudos-digitais/"}
                  >
                    Todos
                  </NavItem>
                  <Query client={dam_client} query={GET_CATEGORIES}>
                    {({ loading, error, data }) => {
                      if (loading) return <div>Carregando...</div>;
                      if (error) {
                        // Google Tag Manager
                        addToDataLayerGTM({
                          event: "erro",
                          etapa: "erro ao buscar categoria"
                        });
                        return <ErrorModal />;
                      }

                      if (!data.category_collections.categories) {
                        return <div>(Vazio)</div>;
                      }

                      return data.category_collections.categories.map(categ => (
                        <NavDropdown
                          eventKey={2}
                          title={categ.title}
                          id="basic-nav-dropdown-right"
                        >
                          <Query
                            client={dam_client}
                            query={GET_SUBCATEGORIES}
                            variables={{ parent_id: categ.id }}
                          >
                            {({ loading, error, data }) => {
                              if (loading) return <div>Carregando...</div>;
                              if (error) {
                                // Google Tag Manager
                                addToDataLayerGTM({
                                  event: "erro",
                                  etapa: "erro ao buscar subcategoria"
                                });
                                return <ErrorModal />;
                              }

                              if (!data.category_collections) {
                                return <div>(Vazio)</div>;
                              }

                              return data.category_collections.categories.map(
                                sub_categ => (
                                  <NavItem
                                    data-gtm-type="click"
                                    data-gtm-clicktype="submenu"
                                    data-gtm-name={sub_categ.title}
                                    onClick={() =>
                                      this.handleClickSubCategoriesGTM(
                                        categ.title,
                                        sub_categ.title
                                      )
                                    }
                                    eventKey={sub_categ.id}
                                    href={
                                      "/#/conteudos-digitais/" + sub_categ.id
                                    }
                                  >
                                    {sub_categ.title}
                                  </NavItem>
                                )
                              );
                            }}
                          </Query>
                        </NavDropdown>
                      ));
                    }}
                  </Query>
                </Nav>
              </div>
            </Row>
          </Grid>
          <Grid fluid>
            <Row>
              <Query
                client={dam_client}
                variables={{
                  module_name: "Media",
                  category_id: this.category_id,
                  limit: this.state.limit,
                  page: this.state.page
                }}
                query={GET_DAM}
              >
                {({ loading, error, data }) => {
                  if (loading) return <div>Carregando...</div>;
                  if (error) {
                    // Google Tag Manager
                    addToDataLayerGTM({
                      event: "erro",
                      etapa: "erro ao buscar coleção de assets"
                    });
                    return <ErrorModal />;
                  }

                  if (
                    !data.assets_collections ||
                    !data.assets_collections.assets.length
                  ) {
                    return (
                      <SearchNotFound
                        onClick={() => (window.location.href = "/#/home")}
                        buttonMessage="Voltar a página inicial"
                      />
                    );
                  }

                  return data.assets_collections.assets.map(item => (
                    <Col lg={4} sm={6}>
                      <div className="media media_asset">
                        <div>
                          <h2>{item.title}</h2>
                          <a
                            data-gtm-type="click"
                            data-gtm-clicktype="download"
                            data-gtm-name={item.title}
                            href={
                              Config.baseUrl +
                              "/api/v1/dam/download/?id=" +
                              item.id +
                              "&file=" +
                              item.asset
                            }
                            download
                            target="_blank"
                          >
                            <Button
                              bsStyle="info"
                              btn-donwload-hover
                              onClick={() => this.handleDownloadGTM(item)}
                            >
                              Baixe aqui
                            </Button>
                          </a>
                          {item.is_viewed ? (
                            <div className="is_viewed">Visualizado</div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </Col>
                  ));
                }}
              </Query>

              <Col />
            </Row>
          </Grid>
          <Paginator
            currentPage={this.state.page}
            pages={Math.ceil(this.state.totalMedia / this.state.limit)}
            onChangePage={page => this.setState({ page })}
            siblingCount={2}
          />
        </div>
      </div>
    );
  }
}

export default MediaCenter;



// WEBPACK FOOTER //
// ./src/views/MediaCenter/MediaCenter.jsx